import { render, staticRenderFns } from "./approver-node.vue?vue&type=template&id=b871df92&scoped=true"
import script from "./approver-node.vue?vue&type=script&lang=js"
export * from "./approver-node.vue?vue&type=script&lang=js"
import style0 from "./approver-node.vue?vue&type=style&index=0&id=b871df92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871df92",
  null
  
)

export default component.exports